module.exports = __webpack_public_path__ + "static/img/21d.01a938d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/art/21d.jpg
// module id = xBic
// module chunks = 0